<template>
  <div>
    <div v-for="(item, n) in packagedElectricityMeters" :key="`${n}-house-electricity`">
      <package-editable-box :isElectricMeter="true" :isGasMeter="false" :packageKey="item.package && item.package.key"
        :isPriceToBeDetermined="item.customPower" :excludingVatPrice="item.package && item.package.homePrice && item.package.homePrice.exVat"
        :meterCount="item.count" :maximumPowerGuaranteed="item.package && item.package.maximumPower.kiloVoltAmpere"
        :selectedFunctionality="'meter.phase.' + item.connectionType" :identifier="n" :wantedPower="item.wantedPower"
        :buildingType="'house'" :onEdit="editElectricityBox" :onDelete="deleteElectricityBox"></package-editable-box>
      <price-disclaimer v-if="item.package && item.package.homePrice && item.package.homePrice.exVat > 0"></price-disclaimer>
    </div>
    <div v-for="(item, n) in modifiedConnections" :key="`${n}-house-modified-connection`">
      <add-connection-editable-box :meterCount="item.count" :selectedFunctionality="'meter.type.' + item.type"
        :identifier="n" :excludingVatPrice="item.price && item.price.exVat" :onEdit="editModifiedConnection"
        :onDelete="deleteModifiedConnection"></add-connection-editable-box>
    </div>



  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ModifiedConnection, PackagedElectricityMeter } from '@/models'
import PackageEditableBox from './PackageEditableBox.vue'
import AddConnectionEditableBox from './AddConnectionEditableBox.vue'
import PriceDisclaimer from './PriceDisclaimer.vue'

@Component({
  components: {
    PackageEditableBox,
    AddConnectionEditableBox,
    PriceDisclaimer
  },
  name: 'house-package-electricity'
})
export default class HousePackageElectricity extends Vue {
  @Prop({ type: Array, required: true }) public packagedElectricityMeters!: PackagedElectricityMeter[]
  @Prop({ type: Array, required: true }) public modifiedConnections!: ModifiedConnection[]

  @Prop({ type: Function, required: true }) public deleteModifiedConnection!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public editModifiedConnection!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public deleteElectricityBox!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public editElectricityBox!: (identifier: number) => void

}
</script>